module.exports = __webpack_public_path__ + "assets/img/bde2d191b3bfece9cbd1866e025603c7.svg";